import paginationService from "../../../../../utils/pagination/pagination.service";
import ContractsMileageListRequest, {
  ContractsMileageListQueryParams,
} from "./contracts-mileage-list.request";

const createQueryParams = (
  request: ContractsMileageListRequest,
): ContractsMileageListQueryParams => {
  return {
    offset:
      !!request.page && !!request.pageSize
        ? paginationService.calculateOffset(request.page, request.pageSize)
        : undefined,
    limit: request.pageSize,
    isValid: request.isValid,
    cargoCompanyId: request.cargoCompanyUuid,
    cargoCompanyName: request.cargoCompanyName,
    order: request.order,
  };
};

const contractsMileageListRequestFactory = {
  createQueryParams,
};

export default contractsMileageListRequestFactory;
